import uuidv4 from 'uuid/v4';

export default function copyAssignments(assignments, projectId) {
  const assignmentsWithNewIds = assignments.map((a) => ({
    ...a,
    newId: uuidv4(),
  }));

  const idMapping = assignmentsWithNewIds.reduce((map, a) => {
    map[a.id] = a.newId;
    return map;
  }, {});

  const newAssignments = assignmentsWithNewIds.map((a) => ({
    ...a,
    id: a.newId,
    copiedFrom: a.id,
    parent: a.parent ? idMapping[a.parent] : null,
    project: projectId,
  }));

  newAssignments.forEach((a) => delete a.newId);

  return newAssignments;
}
